import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import getIsSafari from "selectors/device/getIsSafari";
import { createSelector } from "reselect";

const getIsUIWebView = createSelector(
  [getIsMobileSafari, getIsSafari],
  (isMobileSafari, isSafari) => isMobileSafari && !isSafari,
);

export default getIsUIWebView;
